module.exports = __webpack_public_path__ + "static/media/banner3.27339ad1.jpg";